import { render } from "./index.vue?vue&type=template&id=2fa68098"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2fa68098&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/modals/QuestionnaireModal/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fa68098"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fa68098', __exports__)) {
    api.reload('2fa68098', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2fa68098", () => {
    api.rerender('2fa68098', render)
  })

}


export default __exports__